import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import type { Article, ArticleBody, InsightsAndTipsSlice } from './types';

const initialState: InsightsAndTipsSlice = {
  catalogue: null,
  activeArticleBody: null,
};

const insightsAndTipsSlice = createAppSlice({
  name: 'insightsAndTips',
  initialState,
  reducers: {
    setInsightsAndTipsCatalogue(state, action: PayloadAction<Article[]>) {
      state.catalogue = action.payload;
    },
    setActiveArticleBody(state, action: PayloadAction<ArticleBody>) {
      state.activeArticleBody = action.payload;
    },
    clearActiveArticleBody(state) {
      state.activeArticleBody = null;
    },
  },
});

export const {
  setInsightsAndTipsCatalogue,
  setActiveArticleBody,
  clearActiveArticleBody,
} = insightsAndTipsSlice.actions;

export default insightsAndTipsSlice.reducer;
